import { Button, Form, Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { useShops } from './ShopStore';
import { useForm } from 'antd/es/form/Form';
import { useTeams } from '../Teams/TeamStore';

function Edit(props) {
    let {editShop, ed} = useShops()
    let {teams, getTeams} = useTeams()
    useEffect(()=>{
        getTeams()
    }, [getTeams])
    let [form] = useForm()
    useEffect(()=>{
        form.setFieldsValue(ed)
    }, [ed, form])
    return (
        <Form form={form} layout='vertical'
        onFinish={editShop}
    >
        <Form.Item name={'id'} hidden={true}>
            <Input />
        </Form.Item>
        <Form.Item name={'shopname'} label="Magazin nomi">
            <Input />
        </Form.Item>
        <Form.Item name={'address'} label="Manzili">
            <Input />
        </Form.Item>
        <Form.Item name={'phone'} label="Telefon raqami">
            <Input />
        </Form.Item>
        <Form.Item name={'seller_id'} label="Xodim">
            <Select options={teams.map(t => ({ value: t.id, label: t.name }))} />
        </Form.Item>
        <Form.Item>
            <Button type="primary" htmlType="submit">Qo'shish</Button>
        </Form.Item>
    </Form>
    );
}

export default Edit;